export default {
  products: {
    tire: {
      name: 'ยางรถยนต์',
      fields: {
        name: 'ยางรถยนต์',
        filename: 'เทมเพลตข้อมูลสินค้ายางรถยนต์',
        searchable: 'ชื่อ',
      },
    },
    shock: {
      name: 'โช๊คอัพ',
      fields: {
        name: 'โช๊คอัพ',
        filename: 'เทมเพลตข้อมูลสินค้าโช๊คอัพ',
        searchable: 'ชื่อ',
      },
    },
    brake: {
      name: 'เบรค',
      fields: {
        name: 'เบรค',
        filename: 'เทมเพลตข้อมูลสินค้าเบรค',
        searchable: 'ชื่อ',
      },
    },
    lubricant: {
      name: 'น้ำมันเครื่อง',
      fields: {
        name: 'น้ำมันเครื่อง',
        filename: 'เทมเพลตข้อมูลสินค้าน้ำมันเครื่อง',
        searchable: 'ชื่อ',
        prod_type: {
          label: 'ประเภทน้ำมันเครื่อง',
        },
      },
    },
    battery: {
      name: 'แบตเตอรี่',
      fields: {
        name: 'แบตเตอรี่',
        filename: 'เทมเพลตข้อมูลสินค้าแบตเตอรี่',
        searchable: 'ชื่อ',
        prod_type: {
          label: 'ชนิดแบตเตอรี่',
        },
      },
    },
    other: {
      name: 'อื่นๆ',
      fields: {
        name: 'อื่นๆ',
        filename: 'เทมเพลตข้อมูลสินค้าอื่นๆ',
        searchable: 'ชื่อ',
      },
    },
    common: {
      fields: {
        show: {
          title: 'รายละเอียดสินค้า',
        },
        edit: {
          title: 'แก้ไขสินค้า',
        },
        export: {
          title: 'ดาวน์โหลดเทมเพลตข้อมูล',
        },
        import: {
          title: 'นำเข้าเทมเพลตข้อมูล',
        },
        brand: {
          label: 'ยี่ห้อ',
          title_th: 'ยี่ห้อ (ไทย)',
          title_en: 'ยี่ห้อ (อังกฤษ)',
        },
        model: {
          label: 'รุ่น',
        },
        sub_model: {
          label: 'รุ่นย่อย',
        },
        // prod_item_status: { label: 'สถานะสินค้า N = ปกติ D = ยกเลิกจาหน่าย' },
        prod_item_status: {
          label: 'สถานะสินค้า',
          choices: {
            N: 'ปกติ',
            D: 'ยกเลิกการขาย',
          },
        },
        mat_group_name: {
          label: 'ชื่อกลุ่มสินค้า',
        },
        mat_group_id: {
          label: 'รหัสกลุ่มสินค้า',
        },
        prod_brand_name: {
          label: 'ชื่อยี่ห้อ',
        },
        prod_brand_code: {
          label: 'รหัสยี่ห้อ',
        },
        prod_model_name: {
          label: 'ชื่อรุ่นสินค้า',
        },
        prod_model_code: {
          label: 'รหัสรุ่นสินค้า',
        },
        prod_code: {
          label: 'รหัสสินค้า',
        },
        prod_name: {
          label: 'ชื่อสินค้า',
        },
        prod_name_en: {
          label: 'ชื่อสินค้า(อังกฤษ)',
        },
        prod_name_th: {
          label: 'ชื่อสินค้า(ไทย)',
        },
        tire_spec_height: {
          label: 'ขนาดยาง(สูง)',
        },
        tire_spec_width: {
          label: 'ขนาดยาง(กว้าง)',
        },
        tire_spec_diameter: {
          label: 'ขนาดยาง(เส้นผ่าศูนย์กลาง)',
        },
        prod_size: {
          label: 'ขนาดสินค้า',
        },
        prod_size_unit_th: {
          label: 'หน่วยขนาดบรรจุ (ไทย)',
        },
        prod_size_unit_en: {
          label: 'หน่วยขนาดบรรจุ (อังกฤษ)',
        },
        sale_price: {
          label: 'ราคาขาย',
        },
        price_remark: {
          label: 'หมายเหตุราคาขาย',
        },
        promotion_sale_price: {
          label: 'ส่วนลด PT Max Card Plus (เช่น ส่วนลด 15%)',
        },
        promotion_remark: {
          label: 'เงื่อนไขสิทธิ์ PT Max Card Plus',
        },
        green_card_promotion_sale_price: {
          label: 'ส่วนลด PT Max Card Premier (เช่น ส่วนลด 5%)',
        },
        green_card_promotion_remark: {
          label: 'เงื่อนไขสิทธิ์ PT Max Card Premier',
        },
        ev_card_promotion_sale_price: {
          label: 'ส่วนลด PT Max Card Plus EV (เช่น ส่วนลด 15%)',
        },
        ev_card_promotion_remark: {
          label: 'เงื่อนไขสิทธิ์ PT Max Card Plus EV',
        },
        tire_runflat: {
          label: 'ประเภทยาง Runflat',
          choices: {
            1: 'เป็นยาง Runflat',
            0: 'ไม่เป็นยาง Runflat',
          },
        },
        tire_ev: {
          label: 'ประเภทยาง EV',
          choices: {
            1: 'เป็นยาง EV',
            0: 'ไม่เป็นยาง EV',
          },
        },
        oil_engine: {
          label: 'ประเภทเครื่องยนต์',
        },
        prod_type: {
          label: 'ประเภทอะไหล่',
        },
        prod_axle: {
          label: 'ตำแหน่งติดตั้ง',
        },
        tire_speed_rating: {
          label: 'ขีดจำกัดความเร็วสูงสุด',
        },
        tire_load_index: {
          label: 'ขีดจำกัดรับน้ำหนักต่อล้อ',
        },
        tire_treadwear: {
          label: 'ค่าเปรียบเทียบการสึกหรอ',
        },
        tire_traction: {
          label: 'ความสามารถในการหยุดรถ',
        },
        tire_temperature: {
          label: 'ความสามารถในการระบายความร้อน',
        },
        tire_character: {
          label: 'Tire Character',
        },
        prod_desc_th: {
          label: 'คำบรรยายสินค้า (ไทย)',
        },
        prod_desc_en: {
          label: 'คำบรรยายสินค้า (อังกฤษ)',
        },
        is_highlight: {
          // label: 'Highlight product (แสดงในหน้า Home)'
          label: 'Highlight Product',
        },
        is_active: {
          // label: 'Highlight product (แสดงในหน้า Home)'
          label: 'สถานะ',
        },
        special_flag: {
          // label: 'Flag พิเศษ สินค้าขายดี / สินค้ามาใหม่ / สินค้าโปรโมชั่น  **เลือกได้แค่ 1'
          label: 'Flag พิเศษ',
          choices: {
            P: 'สินค้าโปรโมชั่น', // สินค้าโปรโมชั่น Promotion
            B: 'สินค้าขายดี', // สินค้าขายดี Popular
            H: 'สินค้ามาใหม่', // สินค้ามาใหม่ Hot Deal
          },
        },
        image: {
          label: 'รูปหลัก',
          notfound: 'ไม่มีรูปหลัก',
        },
        thumbnail: {
          label: 'รูป Thumbnail',
          notfound: 'ไม่มีรูป Thumbnail',
        },
        detail_image: {
          label: 'รูป Detail',
          notfound: 'ไม่มีรูป Detail',
        },
        warranty_image: {
          label: 'รูป Warranty',
          notfound: 'ไม่มีรูป Warranty',
        },
        additional_file: {
          label: 'รูปข้อมูลประกอบ (โบรชัวร์)',
        },
        video_url: {
          label: 'Video ประกอบ',
        },
        additional_info: {
          label: 'ข้อมูลเพิ่มเติม',
        },
        oil_viscosity_low_temp: {
          label: 'ค่าความหนืดที่อุณหภูมิต่ำ',
        },
        oil_viscosity_high_temp: {
          label: 'ค่าความหนืดที่อุณหภูมิสูง',
        },
        batt_amp: {
          label: 'ปริมาณแอมป์',
        },
        batt_type: {
          label: 'ประเภทแบต',
        },
        batt_car_type: {
          // label: 'Car Type ประเภท เช่น แบตรถเก๋ง',
          label: 'ประเภทรถ',
        },
        shock_construction: {
          // label: 'Construction โครงสร้าง กระบอก 2 ชั้น (Twin Tube) / กระบอก 1 ชั้น (Monotube)',
          label: 'โครงสร้าง',
        },
        shock_car_type: {
          // label: 'Car Type ประเภท เช่น รถนั่ง',
          label: 'ประเภทรถ',
        },
        shock_type: {
          // label:
          //   'Shock Absorber Type ประเภทโช๊คอัพ โช๊คแก๊ส (Gas Shock Absorber) / โช๊คน้ำมัน (Oil Shock Absorber)',
          label: 'ประเภทโช๊คอัพ',
        },
        slug_th: {
          label: 'Slug (ไทย)',
        },
        slug_en: {
          label: 'Slug (อังกฤษ)',
        },
        has_slug: {
          label: 'Slug',
          choices: {
            true: 'กำหนดค่าแล้ว',
            false: 'ยังไม่กำหนดค่า',
          },
        },
      },
    },
    csv: {
      header: {
        prod_item_status: 'CSS: สถานะสินค้า N = ปกติ D = ยกเลิกจาหน่าย',
        mat_group_name: 'CSS: ชื่อกลุ่มสินค้า',
        mat_group_id: 'CSS: รหัสกลุ่มสินค้า',
        prod_brand_name: 'CSS: ชื่อยี่ห้อ',
        prod_brand_code: 'CSS: รหัสยี่ห้อ',
        prod_model_name: 'CSS: ชื่อรุ่นสินค้า',
        prod_model_code: 'CSS: รหัสรุ่นสินค้า',
        prod_code: 'CSS: รหัสสินค้า',
        prod_name_en: 'CSS: ชื่อสินค้าภาษาอังกฤษ',
        prod_name_th: 'CSS: ชื่อสินค้าภาษาไทย',
        tire_spec_height: 'CSS: ขนาดยาง(สูง)',
        tire_spec_width: 'CSS: ขนาดยาง(กว้าง)',
        tire_spec_diameter: 'CSS: ขนาดยาง(เส้นผ่าศูนย์กลาง)',
        prod_size: 'CSS: ขนาดสินค้า',
        prod_size_unit_th: 'CSS: หน่วยขนาดบรรจุ TH',
        prod_size_unit_en: 'CSS: หน่วยขนาดบรรจุ EN',
        sale_price: 'CSS: ราคาขาย',
        promotion_sale_price: 'ส่วนลด PT Max Card Plus เช่น ส่วนลด 15% / ส่วนลด 500 บาท',
        tire_runflat: 'CSS: ประเภทยาง Runflat 1 = เป็นยาง Runflat 0 = ไม่เป็นยาง Runflat',
        tire_ev: 'CSS: ประเภทยาง EV 1 = เป็นยาง EV 0 = ไม่เป็นยาง EV',
        oil_engine: 'CSS: ประเภทเครื่องยนต์ เบนซิน ดีเซล แก๊ส',
        prod_type:
          'CSS: ประเภทอะไหล่ - เกรดธรรมดา / เกรดกึ่งสังเคราะห์ / เกรดสังเคราะห์แท้ - ชนิดน้ำ / ชนิดแห้ง / ชนิดกึ่งแห้ง',
        prod_axle:
          'CSS: ตำแหน่งติดตั้ง F หน้า (Front) / B หลัง (Rear) L ซ้าย (Left) / R ขวา (Right)',
        tire_speed_rating: 'Speed Rating ขีดจำกัดความเร็วสูงสุด',
        tire_load_index: 'Load Index ขีดจำกัดรับน้ำหนักต่อล้อ',
        tire_treadwear: 'Treadwear ค่าเปรียบเทียบการสึกหรอ',
        tire_traction: 'Traction ความสามารถในการหยุดรถ',
        tire_temperature: 'Temperature ความสามารถในการระบายความร้อน',
        prod_desc_th:
          'คำบรรยายไม่เกิน xxxx ตัวอักษร (ไม่ยาวมาก) raw data ขอเป็น plain text แต่สามารถมาปรับให้เป็น rich text ใน Text Editor บน CMS ได้',
        is_highlight: 'Highlight product (แสดงในหน้า Home)',
        special_flag: 'Flag พิเศษ สินค้าขายดี / สินค้ามาใหม่ / สินค้าโปรโมชั่น  **เลือกได้แค่ 1',
        image: 'รูปหลัก',
        thumbnail: 'รูป thumbnail',
        additional_file: 'รูปข้อมูลประกอบ (โบรชัวร์)',
        video_url: 'Video ประกอบ',
        additional_info: 'ข้อมูลเพิ่มเติม',
        oil_viscosity_low_temp: 'Viscosity in low temp ค่าความหนืดที่อุณหภูมิต่ำ',
        oil_viscosity_high_temp: 'Viscosity in high temp ค่าความหนืดที่อุณหภูมิสูง',
        batt_amp: 'ปริมาณแอมป์',
        batt_car_type: 'Car Type ประเภท เช่น แบตรถเก๋ง',
        shock_construction:
          'Construction โครงสร้าง กระบอก 2 ชั้น (Twin Tube) / กระบอก 1 ชั้น (Monotube)',
        shock_car_type: 'Car Type ประเภท เช่น รถนั่ง',
        shock_type:
          'Shock Absorber Type ประเภทโช๊คอัพ โช๊คแก๊ส (Gas Shock Absorber) / โช๊คน้ำมัน (Oil Shock Absorber)',
      },
    },
  },
}
